import script from "./newPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./newPassword.vue?vue&type=script&setup=true&lang=js"

import "./newPassword.vue?vue&type=style&index=0&id=49242c21&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49242c21"]])

export default __exports__